const a = {
  name: "devices",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10 3.4a.1.1 0 0 0-.1.1V4a.9.9 0 0 1-1.8 0v-.5c0-1.05.85-1.9 1.9-1.9h10c1.05 0 1.9.85 1.9 1.9v15a1.9 1.9 0 0 1-1.9 1.9h-6a.9.9 0 1 1 0-1.8h6a.1.1 0 0 0 .1-.1v-15a.1.1 0 0 0-.1-.1H10ZM2.1 8c0-1.05.85-1.9 1.9-1.9h6c1.05 0 1.9.85 1.9 1.9v12a1.9 1.9 0 0 1-1.9 1.9H4A1.9 1.9 0 0 1 2.1 20V8ZM4 7.9a.1.1 0 0 0-.1.1v12a.1.1 0 0 0 .1.1h6a.1.1 0 0 0 .1-.1V8a.1.1 0 0 0-.1-.1H4ZM14.6 17a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8h-.5a.9.9 0 0 1-.9-.9Zm-8.5 1.5a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["devices"],
  category: "device"
};
export {
  a as devices
};
//# sourceMappingURL=devices.es.js.map
